"use client";

import React from "react";
import { Sparkles } from "lucide-react";

interface TLDRProps {
  children: React.ReactNode;
}

export const TLDR = ({ children }: TLDRProps) => {
  return (
    <div className="my-14 p-6 md:p-8 rounded-[2rem] bg-white/[0.03] border border-white/[0.06] relative overflow-hidden shadow-xl ring-1 ring-white/[0.03]">
      <div className="absolute top-0 right-0 w-32 h-32 bg-brand-1/10 rounded-full blur-[60px] -mr-16 -mt-16" />

      <div className="flex items-start gap-5 relative z-10">
        <div className="shrink-0 w-10 h-10 rounded-xl bg-brand-gradient flex items-center justify-center text-white shadow-lg shadow-brand-1/20 border border-white/10 mt-1">
          <Sparkles className="w-5 h-5 fill-white/20" />
        </div>

        <div>
          <span className="block text-[11px] font-black uppercase tracking-[0.25em] text-brand-1 mb-3">
            Quick Version
          </span>
          <div className="text-text-primary text-[17px] leading-relaxed max-w-none font-medium text-white/90 italic">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TLDR;
